import React, { useState, useEffect } from "react";
import NavbarDashboard from "../../../components/Navbar/NavbarDashboard";
import { Link } from "react-router-dom";
import fundamentals_icon from "../../../assets/images/icon_fundamentals.png";
import "../../../styles/style_label.css";
import LinearProgress from "@mui/joy/LinearProgress";
import Typography from "@mui/joy/Typography";
import { firebase, doc, db, getDoc, auth } from "../../../firebase";
import "firebase/compat/firestore";
import { IoChevronBackOutline } from "react-icons/io5";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../../../styles/tabs.css";

function Progress() {
  let nbsp = "\u00a0";

  // Step 2: Initialize a state variable
  const [quizFinishedValue, setQuizFinishedValue] = useState(0);
  const [quizFinishedValueBraking, setQuizFinishedValue2] = useState(0);
  const [quizFinishedValueFollowing, setQuizFinishedValue3] = useState(0);
  const [quizFinishedValueSpeed, setQuizFinishedValue4] = useState(0);
  const [quizFinishedValueRight, setQuizFinishedValue5] = useState(0);
  const [quizFinishedValueChanging, setQuizFinishedValue6] = useState(0);
  const [quizFinishedValueOvertaking, setQuizFinishedValue7] = useState(0);
  const [quizFinishedValueDriving, setQuizFinishedValue8] = useState(0);
  const completedStyle = { color: "green" };
  const notStartedStyle = { color: "red" };

  const getQuizFinishedStatus = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "topic", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusBraking = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "braking", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue2(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusFollowing = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "following", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue3(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusSpeed = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "speed", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue4(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusRight = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "right", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue5(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusChanging = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "changing", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue6(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusOvertaking = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "overtaking", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue7(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusDriving = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "driving", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue8(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  useEffect(() => {
    getQuizFinishedStatusBraking();
  }, []); //

  useEffect(() => {
    getQuizFinishedStatus();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusFollowing();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusSpeed();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusRight();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusChanging();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusOvertaking();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusDriving();
  }, []);

  const quizStatusText =
    quizFinishedValue === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextBraking =
    quizFinishedValueBraking === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextFollowing =
    quizFinishedValueFollowing === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextSpeed =
    quizFinishedValueSpeed === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextRight =
    quizFinishedValueRight === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextChanging =
    quizFinishedValueChanging === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextOvertaking =
    quizFinishedValueOvertaking === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextDriving =
    quizFinishedValueDriving === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const [activeTab, setActiveTab] = useState(1); // Default to the first tab

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="container-dashboard">
      <NavbarDashboard />

      <div className="container-main-contents">
        <div className="container-main-header">
          <div className="container-main-header-title">
            <Link class="back-button" to={"/"}>
              <IoChevronBackOutline />
            </Link>
            <h1>FUNDAMENTALS</h1>
          </div>

          <p>
            Basic fundamental driving knowledge is crucial for road safety. It
            empowers drivers to make informed decisions and respond effectively
            to unexpected situations, reducing accidents and injuries.
          </p>
          <p>
            Moreover, understanding traffic rules and regulations is a legal
            requirement in most countries. Obtaining a driver's license
            necessitates demonstrating this knowledge, ensuring that drivers
            abide by the law.
          </p>
          <p>
            In essence, basic driving knowledge is the foundation of safe and
            responsible driving, benefiting both individuals and society as a
            whole.
          </p>
        </div>
        <div className="lesson-content">
          <Tabs>
            <TabList className="tab-selector">
              <Tab
                onClick={() => handleTabClick(1)}
                className={activeTab === 1 ? "active-tab tab-ind" : "tab-ind"}
              >
                <h1>Basics</h1>
              </Tab>
            </TabList>

            {activeTab === 1 && (
              <div className="lesson-selection">
                <div className="lesson-selection-card">
                  <h4>Traffic Lights and Signal</h4>
                  <Link to="/fundamentals_1">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusText}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Braking</h4>
                  <Link to="/fundamentals_braking">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextBraking}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Following Distance</h4>
                  <Link to="/fundamentals_braking">
                    <Link to="/fundamentals_following">
                      <p className="start-learning">Start Learning</p>
                    </Link>
                  </Link>
                  <p>{quizStatusTextFollowing}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Driving on the Road</h4>
                  <Link to="/fundamentals_driving">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextDriving}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Speed Restrictions</h4>
                  <Link to="/fundamentals_speed">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextSpeed}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Changing Lanes</h4>
                  <Link to="/fundamentals_changing_lanes">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextChanging}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Overtaking</h4>
                  <Link to="/fundamentals_overtaking">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextOvertaking}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Right of Way</h4>
                  <Link to="/fundamentals_right">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextRight}</p>
                </div>
              </div>
            )}

            {activeTab === 2 && (
              <div className="lesson-selection">
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Changing Lanes</h4>
                  <p className="start-learning">Start Learning</p>
                  <p>{quizStatusText}</p>
                </div>
              </div>
            )}

            {activeTab === 3 && (
              <div className="lesson-selection">
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Test</h4>
                  <p className="start-learning">Start Learning</p>
                  <p>{quizStatusText}</p>
                </div>
              </div>
            )}

            {/* <TabPanel>
              <h2>Basics Page</h2>
            </TabPanel>
            <TabPanel>
              <h2>Additinals Page</h2>
            </TabPanel>
            <TabPanel>
              <h2>Quizzes Page</h2>
            </TabPanel> */}
          </Tabs>
        </div>
      </div>
    </div>
  );
}
export default Progress;
